import { render, staticRenderFns } from "./TrendInspiration.vue?vue&type=template&id=5d1372c8&scoped=true&name=trend-inspiration&"
import script from "./TrendInspiration.vue?vue&type=script&lang=js&"
export * from "./TrendInspiration.vue?vue&type=script&lang=js&"
import style0 from "./TrendInspiration.vue?vue&type=style&index=0&id=5d1372c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1372c8",
  null
  
)

/* custom blocks */
import block0 from "./TrendInspiration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports